/**
 * Helper to get the translated version of a field.
 * If data is a string, returns it (legacy/no translation).
 * If data is an object, returns data[lang] or data['fr'] (fallback).
 */
export const getTranslation = (data, lang = 'fr') => {
  if (!data) return '';
  if (typeof data === 'string') return data;
  
  // If it's an object, try the current lang
  if (data[lang]) return data[lang];
  
  // Fallback to fr, then en, then any key
  if (data['fr']) return data['fr'];
  if (data['en']) return data['en'];
  
  const keys = Object.keys(data);
  if (keys.length > 0) return data[keys[0]];
  
  return '';
};
